"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavMenu = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
require("./styles.scss");
const connect_1 = require("@components/connect");
const helper_1 = require("@components/header/helper");
const NavMenu = () => {
    const [activeLink, setActiveLink] = (0, react_1.useState)("/");
    const location = (0, react_router_dom_1.useLocation)();
    (0, react_1.useEffect)(() => {
        setActiveLink(location.pathname);
    }, [location.pathname]);
    return (React.createElement("nav", { className: "c-header__nav" },
        React.createElement("div", { className: "c-header__links" }, helper_1.ROUTES.map(({ route, id, title }) => {
            return (React.createElement(react_router_dom_1.Link, { className: (0, classnames_1.default)("c-header__link", { "c-header__link-active": activeLink === route }), to: route, key: id }, title));
        })),
        React.createElement("div", { className: "c-header__divider" }),
        React.createElement(connect_1.Connect, null)));
};
exports.NavMenu = NavMenu;
